module.exports = __webpack_public_path__ + "static/media/green01.cb615c44.svg";